<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-date-picker v-model="formDatas.year" type="year" value-format="yyyy" placeholder="选择年"
                        style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-select v-if="formDatas.year" size="mini" v-model="formDatas.asId" filterable clearable
                        @change="partserch" placeholder="请选择商户" style="width: 250px;">
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量撤销</el-button> -->
                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>

                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px"
                        @click="BoxOpen">新增商品兑换收集</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="acrsId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑商品兑换收集' : '新增商品兑换收集'"
                :before-close="handleClose" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
                ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="标题" prop="ascgTitle">
                                <el-input v-model="form.ascgTitle" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="状态" prop="ascgStatus">
                                <el-select v-model="form.ascgStatus" placeholder="请选择" style="width: 80%;">
                                    <el-option label="保存" :value="1"></el-option>
                                    <el-option label="发布" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>

            <!-- 商户账单 -->
            <el-dialog title="商户账单" :visible.sync="diaDetail" width="85%" top="8vh" :close-on-click-modal="false">
                <div style="display: flex; width: 100%;margin: 10px;">
                    <div style="width: 80%; height: 40px">
                        <el-row style="margin: 10px; width: 95%; display: flex;">
                            <el-input v-model="formBill.acrsMoneyAbnormal" size="mini" style="width: 250px;"
                                placeholder="账户异常信息" clearable></el-input>
                            <el-input v-model="formBill.acrsReceiptNameOrg" size="mini" style="width: 250px;"
                                placeholder="开票名称" clearable></el-input>
                            <el-input v-model="formBill.acrsReceiptAbnormal" size="mini" style="width: 250px;"
                                placeholder="发票情况" clearable></el-input>
                            <el-button type="info" size="mini" icon="el-icon-search" @click="getBillList"
                                style="margin-left: 10px">搜索</el-button>

                        </el-row>
                    </div>
                    <div style="width: 10%; height: 40px">
                        <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                            <el-button type="warning" size="mini"  @click="Out2()">导出</el-button>
                        </el-row>
                    </div>
                </div>
                <div>
                    <ve-table ref="vetable" :columns="columnsBill" :table-data="tableDataDetail"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" row-key-field-name="acrsId" style="width: 100%" />
                    <div v-show="tableDataDetail.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCountBill" :page-index="formBill.currentPage"
                        :page-size="formBill.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange_Bill" @on-page-size-change="pageSizeChange_Bill" />
                </div>

            </el-dialog>

        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjefShopListQuick, getAjefCertificateRecordStatisticsYear, addAjefShopCollectionGoods, updateAjefShopCollectionGoods,
    uploadAjefShopStockYidong, updateAjefShopBillRevokeHandler, getAjefCertificateRecordStatisticsYearShop
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            totalCountBill: 1,
            formBill: {
                currentPage: 1,
                pageSize: 15
            },
            getAjefShopList_data: [],
            getAjefShopCollectionGoodsList_data: [],
            bulkImport: false,
            columnsBill: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asName",
                    key: "asName",
                    title: "商户名称",
                    align: "center",
                    edit: false,
                    width: 250,
                },
                {
                    field: "acrsYearExchange",
                    key: "acrsYearExchange",
                    title: "结算年",
                    align: "center",
                    width: 80,
                },

                {
                    field: "acrsYearMonthExchange",
                    key: "acrsYearMonthExchange",
                    title: "结算年月",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "amountFaceYuan",
                    key: "amountFaceYuan",
                    title: "劵面金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "amountSettlementYuan",
                    key: "amountSettlementYuan",
                    title: "结算金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "amountWithdrawYuan",
                    key: "amountWithdrawYuan",
                    title: "已提现金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "amountWithdrawNotYuan",
                    key: "amountWithdrawNotYuan",
                    title: "剩余可提现金额",
                    align: "center",
                    edit: false,
                    width: 260,
                },

                {
                    field: "amountWithdrawCurrentYuan",
                    key: "amountWithdrawCurrentYuan",
                    title: "已提现金额(统计)",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "acrsMoneyWithdrawWxYuan",
                    key: "acrsMoneyWithdrawWxYuan",
                    title: "微信提现金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "acrsMoneyWithdrawPublicYuan",
                    key: "acrsMoneyWithdrawPublicYuan",
                    title: "对公打款",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "acrsMoneyRegisterYuan",
                    key: "acrsMoneyRegisterYuan",
                    title: "注册奖励",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrsMoneyReceiptYuan",
                    key: "acrsMoneyReceiptYuan",
                    title: "发票补差减",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrsMoneyReceiptPlusYuan",
                    key: "acrsMoneyReceiptPlusYuan",
                    title: "发票补差加",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrsMoneyRevokeYuan",
                    key: "acrsMoneyRevokeYuan",
                    title: "退款金额",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrsMoneyAdvanceWithdrawPublicYuan",
                    key: "acrsMoneyAdvanceWithdrawPublicYuan",
                    title: "对公重复打款",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrsMoneyAdvanceWithdrawPublicNotYuan",
                    key: "acrsMoneyAdvanceWithdrawPublicNotYuan",
                    title: "对公重复打款未确认",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "acrsMoneyAbnormal",
                    key: "acrsMoneyAbnormal",
                    title: "账户异常信息",
                    align: "center",
                    edit: false,
                    width: 250,
                },
                {
                    field: "acrsReceiptNameOrg",
                    key: "acrsReceiptNameOrg",
                    title: "开票名称",
                    align: "center",
                    edit: false,
                    width: 250,
                },
                {
                    field: "acrsReceiptAbnormal",
                    key: "acrsReceiptAbnormal",
                    title: "发票情况",
                    align: "center",
                    edit: false,
                    width: 250,
                },
                {
                    field: "acrsReceiptAbnormalMoney",
                    key: "acrsReceiptAbnormalMoney",
                    title: "欠票金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                { field: "updatetime", key: "updatetime", title: "更新时间", width: 160, align: "center" },
            ],
            bulkData: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'acrsId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 15,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acrsYearExchange",
                    key: "acrsYearExchange",
                    title: "结算年",
                    align: "center",
                    width: 80,
                },
                {
                    field: "acrsYearMonthExchange",
                    key: "acrsYearMonthExchange",
                    title: "结算年月",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "amountFaceYuan",
                    key: "amountFaceYuan",
                    title: "劵面金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "amountSettlementYuan",
                    key: "amountSettlementYuan",
                    title: "结算金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "amountWithdrawYuan",
                    key: "amountWithdrawYuan",
                    title: "已提现金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "amountWithdrawNotYuan",
                    key: "amountWithdrawNotYuan",
                    title: "剩余可提现金额",
                    align: "center",
                    edit: false,
                    width: 150,
                },

                {
                    field: "amountWithdrawCurrentYuan",
                    key: "amountWithdrawCurrentYuan",
                    title: "已提现金额(统计)",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "acrsMoneyWithdrawWxYuan",
                    key: "acrsMoneyWithdrawWxYuan",
                    title: "微信提现金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "acrsMoneyWithdrawPublicYuan",
                    key: "acrsMoneyWithdrawPublicYuan",
                    title: "对公打款",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "acrsMoneyRegisterYuan",
                    key: "acrsMoneyRegisterYuan",
                    title: "注册奖励",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrsMoneyReceiptYuan",
                    key: "acrsMoneyReceiptYuan",
                    title: "发票补差减",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrsMoneyReceiptPlusYuan",
                    key: "acrsMoneyReceiptPlusYuan",
                    title: "发票补差加",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrsMoneyRevokeYuan",
                    key: "acrsMoneyRevokeYuan",
                    title: "退款金额",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrsMoneyAdvanceWithdrawPublicYuan",
                    key: "acrsMoneyAdvanceWithdrawPublicYuan",
                    title: "对公重复打款",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrsMoneyAdvanceWithdrawPublicNotYuan",
                    key: "acrsMoneyAdvanceWithdrawPublicNotYuan",
                    title: "对公重复打款未确认",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "acrsMoneyAbnormal",
                    key: "acrsMoneyAbnormal",
                    title: "账户异常信息",
                    align: "center",
                    edit: false,
                    width: 250,
                },
                {
                    field: "acrsReceiptNameOrg",
                    key: "acrsReceiptNameOrg",
                    title: "开票名称",
                    align: "center",
                    edit: false,
                    width: 250,
                },
                {
                    field: "acrsReceiptAbnormal",
                    key: "acrsReceiptAbnormal",
                    title: "发票情况",
                    align: "center",
                    edit: false,
                    width: 250,
                },
                {
                    field: "acrsReceiptAbnormalMoney",
                    key: "acrsReceiptAbnormalMoney",
                    title: "欠票金额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                { field: "updatetime", key: "updatetime", title: "更新时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleMerchantBill(row)}
                                    >
                                        商户账单
                                    </el-button>
                                }

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 15,
            },

            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        getAjefCertificateRecordStatisticsYearShop() {
            getAjefCertificateRecordStatisticsYearShop(this.formBill).then((res) => {
                this.tableDataDetail = res.data;
                this.totalCountBill = res.total;
            });
        },
        pageSizeChange_Bill(pageSize) {
            this.formBill.pageSize = pageSize;
            this.getAjefCertificateRecordStatisticsYearShop();
        },
        pageNumberChange_Bill(pageIndex) {
            console.log(pageIndex);
            this.formBill.currentPage = pageIndex;
            getAjefCertificateRecordStatisticsYearShop(this.formBill).then((res) => {
                this.tableDataDetail = res.data;
                this.totalCountBill = res.total;
                // this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        handleMerchantBill(row) {
            this.formBill = {
                year: row.acrsYearExchange,
                yearMonth: row.acrsYearMonthExchange ? row.acrsYearMonthExchange : '',
                pageSize: 15,
                currentPage: 1,
            }
            getAjefCertificateRecordStatisticsYearShop(this.formBill).then(res => {
                this.tableDataDetail = res.data,
                    this.diaDetail = true,
                    this.totalCountBill = res.total;
            })
        },
        getBillList() {
            this.formBill.currentPage = 1;
            getAjefCertificateRecordStatisticsYearShop(this.formBill).then((res) => {
                this.tableDataDetail = res.data;
                this.totalCountBill = res.total;
            });
        },
        handleDown(row) {
            this.$confirm("是否确定要暂停吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopCollectionGoodsDown({ acrsId: row.acrsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "暂停成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleUp(row) {
            this.$confirm("是否确定要发布吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopCollectionGoodsUp({ acrsId: row.acrsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjefShopStockYidong(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data;
            })
        },
        bulkImportClose(done) {
            done();
            this.bulkData = [];
            this.$nextTick(() => {
                this.getList()
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out2() {
            var s = qs.stringify(this.formBill);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record-statistics/exportAjefCertificateRecordStatisticsYearShop',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '财务统计记录-商户.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record-statistics/exportAjefCertificateRecordStatistics',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '财务统计记录.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },

        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ acrsId: this.theRow.acrsId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        cancelAjefCertificateRecordMulti({ acrsIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },

        handleDelete(row) {
            this.$confirm("是否确定要处理吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopBillRevokeHandler({ acrsId: row.acrsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "处理成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        addAjefShopCollectionGoods(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShopCollectionGoods(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.acrsId = row.acrsId
                    console.log(jsonObj);
                    updateAjefShopCollectionGoods(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjefCertificateRecordStatisticsYear(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjefCertificateRecordStatisticsYear(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjefCertificateRecordStatisticsYear(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>